import {
    FETCHING_BLOGS,
    FETCHING_BLOGS_FAILED,
    FETCHING_BLOGS_SUCCESSFUL,

    FETCHING_POPULAR_BLOGS,
    FETCHING_POPULAR_BLOGS_FAILED,
    FETCHING_POPULAR_BLOGS_SUCCESSFUL,

    FETCHING_FEATURED_BLOGS,
    FETCHING_FEATURED_BLOGS_FAILED,
    FETCHING_FEATURED_BLOGS_SUCCESSFUL,

    FETCHING_SINGLE_BLOG_COMPLETE,
    FETCHING_SINGLE_BLOG,

    ADDING_BLOGS,
    ADDING_BLOGS_FAILED,
    ADDING_BLOGS_SUCCESS,
} from "./types";

export const initialState = {
    fetchingBlogs: false,
    addingBlogs: false,
    fetchingPopularBlogs: false,
    fetchingFeaturedBlog: false,
    popularBlogs: [],
    blogs: {
        data: []
    },
    featuredBlog: {},
    popularBlog: {},
    blogPost: {},
    fetchingSingleBlog: false,
};

export const blogReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDING_BLOGS: return {
            ...state,
            addingBlogs: true,
        }
        case ADDING_BLOGS_FAILED: return {
            ...state,
            addingBlogs: false,
        }
        case ADDING_BLOGS_SUCCESS: return {
            ...state,
            addingBlogs: false,
            blogs: {
                ...state?.blogs,
                data: [action?.blog, ...state?.blogs?.data]
            }
        }
        case FETCHING_BLOGS: return {
            ...state,
            fetchingBlogs: true
        };
        case FETCHING_BLOGS_FAILED: return {
            ...state,
            fetchingBlogs: false,
        }
        case FETCHING_BLOGS_SUCCESSFUL: return {
            ...state,
            fetchingBlogs: false,
            blogs: action?.blogs,
        }
        case FETCHING_POPULAR_BLOGS: return {
            ...state,
            fetchingPopularBlogs: true
        };
        case FETCHING_POPULAR_BLOGS_FAILED: return {
            ...state,
            fetchingPopularBlogs: false
        }
        case FETCHING_POPULAR_BLOGS_SUCCESSFUL: return {
            ...state,
            fetchingPopularBlogs: false,
            popularBlogs: action?.blogs
        }
        case FETCHING_FEATURED_BLOGS: return {
            ...state,
            fetchingFeaturedBlog: true,
        };
        case FETCHING_FEATURED_BLOGS_FAILED: return {
            ...state,
            fetchingFeaturedBlog: false
        }
        case FETCHING_FEATURED_BLOGS_SUCCESSFUL: return {
            ...state,
            fetchingFeaturedBlog: false,
            featuredBlog: action?.blog,
        }
        case FETCHING_SINGLE_BLOG: return {
            ...state,
            fetchingSingleBlog: true
        };
        case FETCHING_SINGLE_BLOG_COMPLETE: return {
            ...state,
            fetchingSingleBlog: false
        }

        
        default:
            return state;
    }
}
